'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagShAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0.00390625 2.00086C0.00390625 0.896286 0.00391972 0.000854492 0.00391972 0.000854492H28.0039C28.0039 0.000854492 28.0039 0.896285 28.0039 2.00086V20.0009C28.0039 20.0009 27.1085 20.0009 26.0039 20.0009H2.0039C0.899338 20.0009 0.00390625 20.0009 0.00390625 20.0009V2.00086Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0.00391972 0.000854492H28.0039V20.0009H0.00390625L0.00391972 0.000854492Z",
          fill: "#07319C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.3374 10.0008C17.3374 8.9071 17.3374 7.61398 17.3374 6.66665C17.3374 5.93027 17.9343 5.33417 18.6707 5.33417H22.6707C23.4071 5.33417 24.0041 5.93028 24.0041 6.66666C24.0041 7.61398 24.0041 8.9071 24.0041 10.0008C24.0041 13.3342 20.6707 14.6675 20.6707 14.6675C20.6707 14.6675 17.3374 13.3342 17.3374 10.0008Z",
          fill: "#8FC5FF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.0941 11.8844C20.0941 11.8844 20.7614 11.0203 21.1539 11.0203C21.5464 11.0203 21.6185 11.5941 22.2221 11.5941C22.8256 11.5941 23.1439 10.6796 23.7253 10.6796C24.3067 10.6796 22.5039 13.0009 22.5039 13.0009L21.0039 14.0009L19.0039 13.5009L20.0941 11.8844Z",
          fill: "#366CC9"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.1301 10.5521L18.7186 10.0009L19.2969 11.4166L20.0732 10.0009L20.7408 14.0362L19.6305 13.8104L18.0039 11.8844L18.1301 10.5521Z",
          fill: "#CF6200"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M18.0039 6.00085H23.5039L24.0041 9.33416H17.3374L18.0039 6.00085Z",
          fill: "#FFFF00"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.0041 10.0008C18.0041 11.4195 18.7064 12.4193 19.45 13.0886C19.8224 13.4238 20.197 13.6675 20.4786 13.8271C20.5495 13.8673 20.6141 13.9019 20.6707 13.931C20.7273 13.9019 20.7919 13.8673 20.8629 13.8271C21.1444 13.6675 21.5191 13.4238 21.8914 13.0886C22.6351 12.4193 23.3374 11.4195 23.3374 10.0008V6.66666C23.3374 6.29902 23.0395 6.00084 22.6707 6.00084H18.6707C18.302 6.00084 18.0041 6.29902 18.0041 6.66665V10.0008ZM17.3374 6.66665V10.0008C17.3374 13.3342 20.6707 14.6675 20.6707 14.6675C20.6707 14.6675 24.0041 13.3342 24.0041 10.0008V6.66666C24.0041 5.93028 23.4071 5.33417 22.6707 5.33417H18.6707C17.9343 5.33417 17.3374 5.93027 17.3374 6.66665Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("rect", { width: 12, height: 8, fill: "#001C5B" }),
      /* @__PURE__ */ jsx("path", { d: "M11.1 8L0 1.3V0H0.9L12 6.6V8H11.1Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M0.9 8L12 1.3V0H11.1L0 6.6V8H0.9Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M2.8 2.70003L0 1.00003V0.400024L3.8 2.70003H2.8Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M9.2 5.29997L12 6.99997V7.59998L8.2 5.29997H9.2Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M8.29999 2.7L12 0.4V0H11.6L7.29999 2.7H8.29999Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M3.70001 5.3L0 7.6V8H0.4L4.70001 5.3H3.70001Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("rect", { x: 4.69995, width: 2.6, height: 8, fill: "white" }),
      /* @__PURE__ */ jsx(
        "rect",
        {
          y: 5.29999,
          width: 2.6,
          height: 12,
          transform: "rotate(-90 0 5.29999)",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("rect", { x: 5.19995, width: 1.6, height: 8, fill: "#CA0028" }),
      /* @__PURE__ */ jsx(
        "rect",
        {
          y: 4.79999,
          width: 1.6,
          height: 12,
          transform: "rotate(-90 0 4.79999)",
          fill: "#CA0028"
        }
      )
    ]
  }
);
const VpFlagShAsset = forwardRef(FlagShAsset);

export { VpFlagShAsset as default };
